export const ClientUpdates = ({ updates }) => (
  <div className="rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-6 sm:p-8" data-testid="portal-updates">
    <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400 mb-6">Daily Updates</p>
    {updates.length === 0 ? (
      <p className="text-sm text-slate-500" data-testid="portal-updates-empty">
        Updates appear here as work progresses — each one is reviewed by Owen before you see it.
      </p>
    ) : (
      <div className="space-y-4">
        {updates.map((u) => (
          <div key={u.date} className="rounded-2xl border border-white/10 p-5" data-testid={`portal-update-${u.date}`}>
            <p className="font-mono-label text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2">
              Day {u.day_number} · {u.date}
            </p>
            <p className="text-sm text-slate-200 leading-relaxed whitespace-pre-wrap">{u.text}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);
